<label [class]="clickable ? 'switch' : 'switch switch--disabled'">
  <input
    (click)="onClick()"
    [checked]="activated"
    [disabled]="!clickable"
    type="checkbox"
  />
  <span [class.slider-disabled]="!clickable" class="slider round"></span>
</label>
